<script>
export default {
    name: "InfoCardsItem",
    props: {
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        logo: {
            type: String,
            required: true,
        },
    }
}
</script>

<template>
    <div class="rounded-2xl border border-indigo-400 p-4 md:p-7 overflow-hidden shadow-lg">
        <img :src="logo" :title="title" :alt="title"
             class="mb-2 w-6 h-6 md:w-8 md:h-8 object-contain">
        <p class="font-semibold text-base md:text-lg mb-2 line-height-24">
            {{ title }}
        </p>
        <p class="font-medium text-xs md:text-[13px] text-gray-800">
            {{ description }}
        </p>
    </div>
</template>

<style scoped lang="scss">
.line-height-24{
    line-height: 24px;
}
</style>
